import { render } from "./Footer.vue?vue&type=template&id=39d8d713&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=39d8d713&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc2-20251202/dbesslnc2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d8d713"]])

export default __exports__